import React, { useState, useEffect } from 'react';
import lead_icon from '../../images/icons/lead_icon.svg';
import './PartnerDash.css';
function CommonDashboardCard({ sendeach, icons }) {
  return (
    <div>
      <div className="card">
        <div>
          <p className="text-black-500 text-xs font-normal font-roboto">
            {sendeach?.status}
          </p>
          <p className="text-2xl font-roboto text-black-500 font-bold">
            {sendeach?.count}
          </p>
        </div>
        <div>
          <img src={icons.icon} alt="" className="w-12 h-12" />
        </div>
        <div>
          <p className="text-black-500 text-xs font-normal font-roboto pb-2 ">
            Amount in (Cr)
          </p>
          <p className="text-sm font-roboto text-black-500 font-bold">
            {sendeach?.amount?.toFixed(2)}
          </p>
        </div>
        <div>
          <p className="text-black-500 text-xs font-normal font-roboto pb-2 ">
            Payout (L)
          </p>
          <p className="text-sm font-roboto text-black-500 font-bold">
            {sendeach?.payout?.toFixed(2)}
          </p>
        </div>
      </div>
    </div>
  );
}

export default CommonDashboardCard;
